import React from "react";
import { AuthZTable } from "../../../../components/authZTable";
import { userGroupListColumns } from "./columnGenerator";
import { useIsIndividualInclusionNamingEnabled } from "../../KeyCondition/common/hooks/IsIndividualInclusionNamingEnabled";

function FilterUserGroups({ userGroupList, columnName, viewMyUserGroups, isViewPermissionMember, displaySearchInPopup = true }) {
  if (viewMyUserGroups === true) {
    userGroupList = userGroupList?.filter((userGroup) => userGroup.isMember === true);
  }

  const isIndividualInclusionNamingEnabled = useIsIndividualInclusionNamingEnabled()

  const columns = userGroupListColumns(
    columnName,
    viewMyUserGroups,
    isViewPermissionMember,
    isIndividualInclusionNamingEnabled
  );

  return (
    <AuthZTable
      name="user-group-list"
      rowKey="id"
      dataSource={userGroupList}
      columns={columns}
      pagination={false}
      displaySearchInPopup={displaySearchInPopup}
    />
  );
}

export default FilterUserGroups;
